import { createWebHistory, createRouter } from 'vue-router'
import log from '@/plugin/logger.ts'
import { common as commonUtil } from '@/assets/js/common.js'
import store from '@/store'

import CustomerLayout from './layouts/Customer.vue'
import AdminLayout from './layouts/Admin.vue'
import DefaultLayout from './layouts/Default.vue'


import HomePage from './pages/Home'
import Login from './pages/Login'
import DashBoard from './pages/admin/DashBoard'


/* Admin page */
import AdminParcelInfo from './pages/admin/logis/ParcelInfo'
import AdminDashboardOrderList from './pages/admin/logis/DashboardOrderList.vue'
import AdminPacking from './pages/admin/logis/Packing'
import AdminConsolManage from './pages/admin/logis/ConsolManage'
import AdminHblNoManage from './pages/admin/logis/HblNoManage'
import AdminHsCodeManage from './pages/admin/logis/HsCodeManage.vue'
import AdminPickupRequest from './pages/admin/logis/ExportPickupRequest'

import FreightManage from './pages/admin/logis/FreightManage'

import CourierManage from './pages/admin/logis/CourierManage'
import PickupManage from './pages/admin/logis/PickupManage'
import LocationManage from './pages/admin/logis/LocationManage'

import CustomerManage from './pages/admin/CustomerManage'
import PartnerManage from './pages/admin/PartnerManage'

import NoticeBoardManage from './pages/admin/NoticeBoard'
import CustomerInqueryManage from './pages/admin/CustomerInquery'

import ManageSchedule from './pages/admin/logis/ManageSchedule'
import BackupManagement from './pages/admin/BackupManage'
import SchemaSnapshotManage from './pages/admin/SchemaSnapshotManage.vue'
import CodeManagement from './pages/admin/CodeManage'
import LogisSampleDataManage from './pages/admin/LogisSampleDataManage.vue'

import UpdateReport from './pages/admin/UpdateReport'

import Lab from './pages/admin/Lab'

import LoginHistoryManage from './pages/admin/LoginHistoryManage.vue'
import UserBehaviorTracking from './pages/admin/UserBehaviorTracking.vue'


import AdminSkuRequestDetail from './pages/admin/fulfillment/SkuRequestDetail.vue'
import AdminMasterSkuList from './pages/admin/fulfillment/MasterSkuList.vue'
import AdminMasterSkuRegister from './pages/admin/fulfillment/MasterSkuRegister.vue'
import AdminMasterSkuDetail from './pages/admin/fulfillment/MasterSkuDetail.vue'
import MasterDataManage from './pages/admin/fulfillment/MasterDataManage.vue'
import AdminFulfillmentOpsDashboard from './pages/admin/fulfillment/FulfillmentOpsDashboard.vue'
import RequestMappingManage from './pages/admin/fulfillment/RequestMappingManage.vue'
import PackingExpressRuleManage from './pages/admin/fulfillment/PackingExpressRuleManage.vue'
import PartnerOrderReceiving from './pages/admin/fulfillment/PartnerOrderReceiving.vue'
import InventoryHome from './pages/admin/inventory/InventoryHome.vue'



/* Customer page */
import AboutUs from './pages/customer/AboutUs'

import Service from './pages/customer/Service'
import ServiceFlight from './pages/customer/ServiceFlight'
import ServiceOcean from './pages/customer/ServiceOcean'

import NoticeBoard from './pages/customer/NoticeBoard'
import ParcelInfoCust from './pages/customer/ParcelInfo'
// import RegiParcel from './pages/customer/ParcelRegistration'
import OrderRegiAusToKor from './pages/customer/OrderRegiAusToKor'

import ShippingInfo from './pages/customer/ShippingInfo'

import SignUp from './pages/customer/SignUp'

import ResetPassword from './pages/customer/ResetPassword.vue'
import { resolveDefaultAuthenticatedRoute } from '@/utils/authRouting'
import { hasServiceAccess } from '@/utils/serviceWorkspace'
import PartnerFulfillmentHome from './pages/admin/fulfillment/PartnerFulfillmentHome.vue'
import PartnerSkuRequestList from './pages/admin/fulfillment/PartnerSkuRequestList.vue'
import PartnerSkuProductDetail from './pages/admin/fulfillment/PartnerSkuProductDetail.vue'

/* Homepage defaults */
// import Error404 from './pages/etc/404'

const customerTitle = "Aone Logistics | "
const bizTitle = "Aone Logistics BIZ | "
const adminTitle = "Aone 관리자 | "
const ACCESS_DENIED_MESSAGE = '계약되지 않은 서비스입니다.'
const ADMIN_ONLY_MESSAGE = '해당 메뉴는 최고관리자만 접근할 수 있습니다.'
const isLocalEnv = String(process.env.VUE_APP_ENV_LEVEL || '').toUpperCase() === 'LOCAL'

// Vue 라우터 인스턴스 생성
const router = createRouter({
  history: createWebHistory(),
  routes: [
    //******** Business page *******//
    {
      path: "/biz",
      name: "BizHome",
      component: CustomerLayout,
      children: [
        {
          path: '',
          name : 'BIZ 홈페이지',
          component: HomePage,
          meta : {
            title: bizTitle + "홈페이지",
            description: "AONE Logistics 비즈니스 물류 서비스"
          },
        },
        {
          path: 'service',
          name : 'BIZ 서비스 설명',
          component: Service,
          meta : {
            title: bizTitle + "서비스 설명"
          },
        },
        {
          path: 'service-flight',
          name : 'BIZ 서비스 - 항공',
          component: ServiceFlight,
          meta : {
            title: bizTitle + "서비스 - 항공"
          },
        },
        {
          path: 'service-ocean',
          name : 'BIZ 서비스 - 해상',
          component: ServiceOcean,
          meta : {
            title: bizTitle + "서비스 - 해상"
          },
        },
        {
          path: 'notice',
          name : 'BIZ 공지사항',
          component: NoticeBoard,
          meta : {
            title: bizTitle + "공지사항"
          },
        },
        {
          path: 'parcel-info',
          name : 'BIZ 배송조회',
          component: ParcelInfoCust,
          meta : {
            title: bizTitle + "배송조회",
            localOnly: true
          },
        },
        {
          path: 'parcel-reg-aus-to-kor',
          name : 'BIZ 배송등록 호주 -> 한국',
          component: OrderRegiAusToKor,
          meta : {
            title: bizTitle + "배송등록 호주 -> 한국"
          },
        },
        {
          path: 'shipping-infomation',
          name : 'BIZ 운송정보',
          component: ShippingInfo,
          meta : {
            title: bizTitle + "운송정보"
          },
        },
        {
          path: 'aboutUs',
          name : 'BIZ About us',
          component: AboutUs,
          meta : {
            title: bizTitle + "About us"
          },
        },
      ],
      meta: {
        authRequired : false
      },
    },

    //******** Legacy customer/biz-compatible page *******//
    {
      path: "/",
      name: "HomePage",
      component: CustomerLayout,
      children: [
        { path: '/',
          name : '홈페이지', 
          component: HomePage,
          meta : {
            title: customerTitle + "홈페이지",
            description: "어디든 달려가는 호주글로벌 로지스틱스"
          },
        },
        { path: '/service',
          name : '서비스 설명',
          component: Service,
          meta : {
            title: customerTitle + "서비스 설명"
          },
        },
        { 
          path: '/service-flight',
          name : '서비스 - 항공',
          component: ServiceFlight,
          meta : {
            title: customerTitle + "서비스 - 항공"
          },
        },
        { 
          path: '/service-ocean',
          name : '서비스 - 해상',
          component: ServiceOcean,
          meta : {
            title: customerTitle + "서비스 - 해상"
          },
        },
        { 
          path: '/notice',
          name : '공지사항',
          component: NoticeBoard,
          meta : {
            title: customerTitle + "공지사항"
          },
        },
        { 
          path: '/parcel-info',
          name : '배송조회',
          component: ParcelInfoCust,
          meta : {
            title: customerTitle + "배송조회",
            localOnly: true
          },
        },
        /*
        { 
          path: '/parcel-registration',
          name : '배송등록 한국 -> 호주',
          component: RegiParcel,
          meta : {
            title: customerTitle + "배송등록 한국 -> 호주"
          },
        },
        */
        { 
          path: '/parcel-reg-aus-to-kor',
          name : '배송등록 호주 -> 한국',
          component: OrderRegiAusToKor,
          meta : {
            title: customerTitle + "배송등록 호주 -> 한국"
          },
        },
        { 
          path: '/shipping-infomation',
          name : '운송정보',
          component: ShippingInfo,
          meta : {
            title: customerTitle + "운송정보"
          },
        },
        { 
          path: '/signUp',
          name : '회원가입',
          component: SignUp,
          meta : {
            title: customerTitle + "회원가입"
          },
        },
        { 
          path: '/login',
          name : '로그인',
          component: Login,
          meta : {
            title: customerTitle + "로그인"
          },
        },
        { 
          path: '/aboutUs', // 현재 미사용
          name : 'About us', 
          component: AboutUs,
          meta : {
            title: customerTitle + "About us"
          },
        },



        /******************************************
         * Login compatibility & password reset
         ******************************************/
        { 
          path: '/partnerAdmin',
          redirect: '/login'
        },
        { 
          path: '/reset-password',
          name : '비밀번호 재설정',
          component: ResetPassword,
          meta : {
            title: customerTitle + "비밀번호 재설정"
          },
        },
      ],
      meta: {
        authRequired : false
      },
    },

    //******** Admin page *******//
    {
      path: "/admin",
      name: "Admin",
			component: AdminLayout,
      children: [
				{
					path: "/admin/dashboard",
					name: "DashBoard",
					component: DashBoard,
          meta : {
            title: adminTitle + "대쉬보드"
          },
          authLevel: 80
				},
        {
          path: "/admin/inventory",
          name: "Admin-inventory-home",
          component: InventoryHome,
          meta: {
            title: adminTitle + "Inventory",
            service: "inventory"
          },
          authLevel: 80
        },
				{
					path: "/admin/parcel-info",
					name: "Admin-parcel-infomation",
					component: AdminParcelInfo,
          meta : {
            title: adminTitle + "배송상품조회"
          },
					authLevel: 80
				},
				{
					path: "/admin/dashboard/orders",
					name: "Admin-dashboard-orders",
					component: AdminDashboardOrderList,
          meta : {
            title: adminTitle + "대시보드 조회 목록"
          },
					authLevel: 80
				},
        {
          path: "/admin/packing",
          name: "Admin-packing",
          component: AdminPacking,
          meta: {
            title: adminTitle + "포장관리"
          },
          authLevel: 80
        },
        {
					path: "/admin/console",
					name: "Admin-console-management",
					component: AdminConsolManage,
          meta : {
            title: adminTitle + "콘솔"
          },
          authLevel: 90
				},
        {
					path: "/admin/hbl-no-manage",
					name: "Admin-hbl-no-management",
					component: AdminHblNoManage,
          meta : {
            title: adminTitle + "화물번호 대역폭관리"
          },
          authLevel: 90
				},
        {
					path: "/admin/hs-code-manage",
					name: "Admin-hs-code-management",
					component: AdminHsCodeManage,
          meta : {
            title: adminTitle + "HS CODE 관리"
          },
          authLevel: 90
				},
        { 
          path: '/admin/freight-manage',
          name : 'Admin-Freight-Management',
          component: FreightManage,
          meta : {
            title: adminTitle + "운송편관리"
          },
          authLevel: 90
        },
        {
					path: "/admin/pickup-request-list",
					name: "Admin-Export-Pickup-Request-List",
					component: AdminPickupRequest,
          meta : {
            title: adminTitle + "픽업요청"
          },
          authLevel: 90
				},
				{ // 택배사 관리
					path: "/admin/courier-manage",
					name: "Admin-courier-manage",
					component: CourierManage,
          meta : {
            title: adminTitle + "택배사관리"
          },
          authLevel: 90
				},
				{ // 픽업지 관리
					path: "/admin/pickup-manage",
					name: "Admin-pickup-manage",
					component: PickupManage,
          meta : {
            title: adminTitle + "픽업지관리"
          },
          authLevel: 90
				},

				{ // 배송위치 관리 - 현재 미사용
					path: "/admin/location-manage",
					name: "Admin-location-manage",
					component: LocationManage,
          meta : {
            title: adminTitle + "배송위치관리"
          },
          authLevel: 90
				},
				{ // 고객관리
					path: "/admin/customer-manage",
					name: "Admin-customer-manage",
					component: CustomerManage,
          meta : {
            title: adminTitle + "고객관리"
          },
          authLevel: 90
				},
        { // 파트너 관리
					path: "/admin/partner-manage",
					name: "Admin-partner-manage",
					component: PartnerManage,
          meta : {
            title: adminTitle + "파트너사관리"
          },
          authLevel: 90
				},
        { // 공지사항 관리
					path: "/admin/common/notice",
					name: "Admin-notice-manage",
					component: NoticeBoardManage,
          meta : {
            title: adminTitle + "공지사항관리"
          },
          authLevel: 90
				},
        { // 고객문의관리
					path: "/admin/inquery",
					name: "Admin-customer-inquery-manage",
					component: CustomerInqueryManage,
          meta : {
            title: adminTitle + "고객문의관리"
          },
          authLevel: 90
				},
        { // 일정 관리
					path: "/admin/manage-schedule",
					name: "Admin-manage-schedule",
					component: ManageSchedule,
          meta : {
            title: adminTitle + "일정관리"
          },
          authLevel: 80
				},
        { // 코드관리
          path: "/admin/common/code-management",
          name: "Admin-code-management",
          component: CodeManagement,
          meta : {
            title: adminTitle + "코드관리"
          },
          authLevel: 90
        },
        { // 데이터백업
          path: "/admin/common/backup-management",
          name: "Admin-backup-management",
          component: BackupManagement,
          meta : {
            title: adminTitle + "데이터백업"
          },
          authLevel: 90
        },
        { // DB 스키마 스냅샷
          path: "/admin/common/schema-snapshots",
          name: "Admin-schema-snapshots",
          component: SchemaSnapshotManage,
          meta : {
            title: adminTitle + "DB 스키마 스냅샷"
          },
          authLevel: 90
        },
        { // 운영 샘플 데이터
          path: "/admin/common/logis-sample-data",
          name: "Admin-logis-sample-data",
          component: LogisSampleDataManage,
          meta : {
            title: adminTitle + "운영 샘플 데이터"
          },
          authLevel: 90
        },
        { // 업데이트 리포트
					path: "/admin/common/update-report",
					name: "Admin-udpate-report",
					component: UpdateReport,
          meta : {
            title: adminTitle + "업데이트 리포트"
          },
          authLevel: 90
				},
        { // 실험실
					path: "/admin/lab",
					name: "Admin-lab",
          component: Lab,
          meta : {
            title: adminTitle + "실험실"
          },
          authLevel: 99
				},
        { // 인증·접속 이력
					path: "/admin/common/login-history-manage",
					name: "Admin-login-history-manage",
          component: LoginHistoryManage,
          meta : {
            title: adminTitle + "인증·접속 이력",
            minAuth: 90
          }
				},
        { // 사용자 활동 로그
					path: "/admin/common/user-behavior-tracking",
					name: "Admin-user-behavior-tracking",
          component: UserBehaviorTracking,
          meta : {
            title: adminTitle + "사용자 활동 로그",
            minAuth: 90
          }
				},
        { // Partner - SKU 요청 목록 (Admin layout 공통 사용)
          path: "/admin/fulfillment/home",
          name: "Partner-fulfillment-home",
          component: PartnerFulfillmentHome,
          meta: {
            title: adminTitle + "내 상품 현황"
          },
          authLevel: 80
        },
        { // Partner - SKU 요청 등록
          path: "/admin/fulfillment/request/new",
          name: "Partner-sku-request-new",
          component: PartnerSkuRequestList,
          meta: {
            title: adminTitle + "상품 요청 등록"
          },
          authLevel: 80
        },
        { // Partner - SKU 요청 목록 (Admin layout 공통 사용)
          path: "/admin/fulfillment/sku-requests",
          name: "Partner-sku-requests",
          component: PartnerSkuRequestList,
          meta: {
            title: adminTitle + "내 상품목록 관리"
          },
          authLevel: 80
        },
        { // Partner - 내 상품 상세
          path: "/admin/fulfillment/my-products/detail",
          name: "Partner-sku-product-detail",
          component: PartnerSkuProductDetail,
          meta: {
            title: adminTitle + "내 상품 상세"
          },
          authLevel: 80
        },
        { // Fulfillment - 승인 목록
          path: "/admin/fulfillment/request-mappings",
          name: "Admin-request-mappings",
          component: RequestMappingManage,
          meta: {
            title: adminTitle + "요청/매핑 관리"
          },
          authLevel: 90
        },
        { // Fulfillment - 승인 목록
          path: "/admin/fulfillment/approvals",
          redirect: (to) => {
            const query = { ...to.query }
            const status = String(query.status || '')
            delete query.status

            return {
              path: "/admin/fulfillment/request-mappings",
              query: {
                ...query,
                tab: status === 'REJECTED' ? 'rejected' : 'requested'
              }
            }
          }
        },
        { // Fulfillment - 운영 현황
          path: "/admin/fulfillment/operations",
          name: "Admin-fulfillment-operations",
          component: AdminFulfillmentOpsDashboard,
          meta: {
            title: adminTitle + "상품 운영 현황"
          },
          authLevel: 90
        },
        { // Fulfillment - 승인 상세
          path: "/admin/fulfillment/approvals/:id",
          name: "Admin-sku-request-detail",
          component: AdminSkuRequestDetail,
          meta: {
            title: adminTitle + "승인 대기 상세"
          },
          authLevel: 90
        },
        { // Fulfillment - Master SKU 목록
          path: "/admin/fulfillment/master-skus",
          name: "Admin-master-skus",
          component: AdminMasterSkuList,
          meta: {
            title: adminTitle + "목록 조회"
          },
          authLevel: 90
        },
        { // Fulfillment - Master SKU 등록
          path: "/admin/fulfillment/products/register",
          name: "Admin-master-sku-register",
          component: AdminMasterSkuRegister,
          meta: {
            title: adminTitle + "신규 등록"
          },
          authLevel: 90
        },
        { // Fulfillment - 익스프레스 규칙 관리
          path: "/admin/fulfillment/packing/express-rules",
          name: "Admin-packing-express-rules",
          component: PackingExpressRuleManage,
          meta: {
            title: adminTitle + "익스프레스 규칙 관리",
            minAuth: 90
          }
        },
        { // Logis - 파트너 오더 입고처리
          path: "/admin/fulfillment/packing/receiving",
          name: "Admin-partner-order-receiving",
          component: PartnerOrderReceiving,
          meta: {
            title: adminTitle + "파트너 오더 입고처리",
            minAuth: 90
          }
        },
        { // Fulfillment - 브랜드/카테고리 관리
          path: "/admin/fulfillment/master-data",
          name: "Admin-fulfillment-master-data",
          component: MasterDataManage,
          meta: {
            title: adminTitle + "브랜드/카테고리 관리"
          },
          authLevel: 90
        },
        {
          path: "/admin/fulfillment/brands",
          redirect: () => ({
            path: "/admin/fulfillment/master-data",
            query: { tab: "brand" }
          })
        },
        {
          path: "/admin/fulfillment/categories",
          redirect: () => ({
            path: "/admin/fulfillment/master-data",
            query: { tab: "category" }
          })
        },
        { // Fulfillment - 매핑 현황
          path: "/admin/fulfillment/mappings",
          redirect: (to) => ({
            path: "/admin/fulfillment/request-mappings",
            query: {
              ...to.query,
              tab: "pending"
            }
          })
        },
        { // Fulfillment - Master SKU 상세
          path: "/admin/fulfillment/master-skus/:id",
          name: "Admin-master-sku-detail",
          component: AdminMasterSkuDetail,
          meta: {
            title: adminTitle + "상품 상세"
          },
          authLevel: 90
        },
			],
      meta : {
        authRequired : true,
				authLv : "admin"
      },
    },
  ]
})


/**
 * 
 * Hook 페이지 이동 전 확인
 * 
 * . 메타영역 정의
 *  . 타이틀 설정
 *  . 설명
 *  . 로그인 필요여부 판단
 *  . 파트너 레벨 체크
 * 
 * 
 */
router.beforeEach(async (to, from, next) => {
  log.debug("beforeEach - 1. beforeEach 실행됨")
  log.debug("beforeEach to = ", to)
  log.debug("from = ", from)

  // 타이틀 설정
  const title = to.meta.title
  if (title) {
    document.title = title
  }

  // 설명 (meta tag로 관리 권장)
  const description = to.meta.description
  if (description) {
    const meta = document.querySelector('meta[name="description"]') || document.createElement('meta')
    meta.setAttribute('name', 'description')
    meta.setAttribute('content', description)
    if (!meta.parentNode) document.head.appendChild(meta)
  }

  if (to.matched.some(routeInfo => routeInfo.meta.localOnly) && !isLocalEnv) {
    log.debug("beforeEach - localOnly 페이지 차단: " + to.path)
    return next('/biz')
  }

  // 로그인이 필요한 페이지 인지 판단.
  const auth = to.matched.some(routeInfo => routeInfo.meta.authRequired)

  if (auth) {
    log.debug("beforeEach - 2.1 로그인 필요 페이지")
    const ok = await routerCheckSession()
    if (ok) {
      const user = store.getters.getLocalSession || {}
      const isPartner = Number(user?.authLevel) === 80
      const requiredAuthLevel = to.matched.reduce(
        (required, routeInfo) => Math.max(required, Number(routeInfo.meta?.minAuth || 0)),
        0
      )

      if (requiredAuthLevel && Number(user?.authLevel || 0) < requiredAuthLevel) {
        alert(ACCESS_DENIED_MESSAGE)
        return next(resolveDefaultAuthenticatedRoute(user))
      }

      if (to.path === '/admin') {
        return next(resolveDefaultAuthenticatedRoute(user))
      }

      // 파트너 서비스 등록 상태 기반 접근 통제
      if (isPartner && to.path.startsWith('/admin/inventory') && !hasServiceAccess(user, 'inventory')) {
        alert(ACCESS_DENIED_MESSAGE)
        return next(resolveDefaultAuthenticatedRoute(user))
      }
      if (
        isPartner &&
        (to.path === '/admin/packing' || to.path.startsWith('/admin/fulfillment')) &&
        !hasServiceAccess(user, 'fulfillment')
      ) {
        alert(ACCESS_DENIED_MESSAGE)
        return next(resolveDefaultAuthenticatedRoute(user))
      }
      if (
        isPartner &&
        (to.path.startsWith('/admin/parcel-info') || to.path.startsWith('/admin/manage-schedule')) &&
        !hasServiceAccess(user, 'logis')
      ) {
        alert(ACCESS_DENIED_MESSAGE)
        return next(resolveDefaultAuthenticatedRoute(user))
      }
      if (isPartner && (to.path.startsWith('/admin/fulfillment/approvals') || to.path.startsWith('/admin/fulfillment/master-skus'))) {
        alert(ADMIN_ONLY_MESSAGE)
        return next('/admin/fulfillment/home')
      }

      log.debug("beforeEach - 2.1.1.1 로그인 되어 있음")
      log.debug("beforeEach - routing success : '" + to.path + "'")
      return next()
    } else {
      // Vuex 세션만 정리하고 persisted 키만 제거
      // store.dispatch('destroyCustomerInfo')
      // sessionStorage.removeItem('vuexStore')
      log.debug("beforeEach - 2.1.1.2 로그인 되어 있지 않음")
      alert("로그인이 필요한 페이지 입니다.")
      return next('/login')
    }
  } else {
    log.debug("beforeEach - 2.2 로그인 미필요 페이지")
    log.debug("beforeEach - routing success : '" + to.path + "'")
    return next()
  }
})


/**
 * 
 * Hook 페이지 이동 후 공통 실행부
 * 
 * . 페이지 최상단으로 이동
 * 
 */
router.afterEach(() => {
  log.debug("afterEach - 1. afterEach 실행됨")
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
})



/**
 * 
 * Name : routerCheckSession
 * 
 * 
 * Description
 * 
 * . 메타영역 정의
 *  . 타이틀 설정
 *  . 설명
 *  . 로그인 필요여부 판단
 * 
 * 
 */
const routerCheckSession = async () => {
  log.debug("beforeEach - 2.1.1 routerCheckSession 실행됨")

  const config = {
    method: 'GET',
    url: `/api/admin/getSession?_=${Date.now()}`,
    name: '[ AXIOS / 관리자 세션확인 ]'
  }

  try {
    const res = await commonUtil.http(config)
    log.debug('/admin/getSession 실행됨', res)

    // 로그인이 되어 있는 경우
    if (res.status === 200 && res.data && res.data.isLogin) {
      log.debug('res.data.isLogin = true', res.data.isLogin)
      log.debug('res.data', res.data)
      // 로그인 성공시
      let userData = res.data.user
      store.dispatch('setCustomerInfo', userData)
      return true
    } else {
      log.debug('res.data.isLogin = false', res.data && res.data.isLogin)
      store.dispatch('destroyCustomerInfo')
      sessionStorage.removeItem('vuexStore')
      return false
    }

  } catch (err) {
    log.debug('/admin/getSession 실패', err)
    store.dispatch('destroyCustomerInfo')
    sessionStorage.removeItem('vuexStore')
    return false
  }
}


/**
 * 개발용 페이지 라우팅
 */
if (process.env.VUE_APP_ENV_LEVEL === 'LOCAL' || process.env.VUE_APP_ENV_LEVEL === 'DEVELOPMENT') {
  router.addRoute({
    path: '/dev',
    component: DefaultLayout, // 👈 기존 레이아웃 재사용
    children: [
      {
        path: 'dev-tools',
        name: 'DevTools',
        component: () => import('@/pages/dev/DevTools.vue'),
      },
      {
        path: 'comp-tester',
        name: 'CompTester',
        component: () => import('@/pages/dev/CompTester.vue'),
      }
    ]
  })
}

export default router
